/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="m12.0007 0 10.5155 5.7362a.7943.7943 0 0 1 .1707.093l.313.1708v.414a1.2826 1.2826 0 0 1 0 .0278V18l-10.9992 6-11.0006-6V6.4417a.7324.7324 0 0 1 0-.0277V6l.3129-.1706a.7956.7956 0 0 1 .171-.0933L12.0007 0ZM2.5715 7.721v8.5584l3.5381-1.9301c.3768-.2055.8577-.0811 1.073.2786.2153.3596.0844.8178-.2923 1.0233l-3.5144 1.917 7.8384 4.2753v-9.4083L2.5715 7.721Zm10.2142 4.7142v9.4083l7.8391-4.2756-3.5143-1.9167c-.3767-.2055-.5076-.6636-.2924-1.0233.2153-.3596.6953-.4846 1.072-.2791l3.5384 1.9299V7.721l-8.6428 4.7142Zm7.8388-6.0033L12 11.1362 3.3757 6.4319l7.8386-4.2754V6.75c0 .4142.3518.75.7857.75.4339 0 .7857-.3358.7857-.75V2.1565l7.8388 4.2754Z"
    clipRule="evenodd"
  />,
  'ProjectCubic'
);
